import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import FilterDrawer from '../../../shared/FilterDrawer';
import { formatDateWords } from '../../../shared/tenantClock';

const TYPE_LABELS = { individual: 'Individual', organization: 'Organisation' };

// Read-only "who attended this Trade Show" list, opened from a row's
// "View Attendees" action — the screen answering "who did I meet at this
// show" (and, by revisiting the same series' other years, "who did I meet
// last time / the time before").
function TradeShowAttendeesDrawer({ open, onOpenChange, tradeShow }) {
  const navigate = useNavigate();
  const [attendees, setAttendees] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open || !tradeShow) return;
    setLoading(true);
    axios.get(`/api/trade-shows/${tradeShow.id}/attendees`)
      .then((res) => setAttendees(res.data.data?.attendees || []))
      .catch(() => setAttendees([]))
      .finally(() => setLoading(false));
  }, [open, tradeShow]);

  const title = tradeShow ? `${tradeShow.series?.name || ''} ${tradeShow.year}` : 'Attendees';
  const dateLabel = tradeShow?.start_date
    ? `Every Commercial Entity recorded as attending this Trade Show (${formatDateWords(tradeShow.start_date)}${tradeShow.end_date && tradeShow.end_date !== tradeShow.start_date ? ` – ${formatDateWords(tradeShow.end_date)}` : ''}).`
    : 'Every Commercial Entity recorded as attending this Trade Show.';

  return (
    <FilterDrawer
      open={open}
      onOpenChange={onOpenChange}
      title={title}
      description={dateLabel}
    >
      {loading ? (
        <div style={{ padding: '8px 0', fontSize: 14, color: '#888' }}>Loading...</div>
      ) : attendees.length === 0 ? (
        <div style={{ padding: '8px 0', fontSize: 14, color: '#888' }}>No attendees recorded yet.</div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {attendees.map((a) => (
            <div
              key={a.id}
              onClick={() => navigate(`/commercial-entities/${a.commercial_entity.id}`)}
              style={{ padding: '10px 12px', border: '1px solid #e3e7ee', borderRadius: 6, cursor: 'pointer' }}
              title="Open record"
            >
              <div style={{ fontWeight: 600, fontSize: 14 }}>{a.commercial_entity?.name}</div>
              <div style={{ fontSize: 12, color: '#666', marginTop: 2 }}>
                {TYPE_LABELS[a.commercial_entity?.type] || a.commercial_entity?.type} &middot; {a.role?.name}
              </div>
              {a.notes && <div style={{ fontSize: 12, color: '#888', marginTop: 4 }}>{a.notes}</div>}
            </div>
          ))}
        </div>
      )}
    </FilterDrawer>
  );
}

export default TradeShowAttendeesDrawer;
